export default {
    SignIn: 'Sign in',
    Join: 'Create account',
    ContactUs: 'Contact us',
    savedHomes: 'Favorite homes',
    MortgageCalculator: 'Mortgage calculator',
    HomesforSale: 'Homes for sale',
    HomesforRent: 'Homes for rent',
    ApartmentsForRent: 'Apartments for rent',
    OpenHouses: 'Open houses',
    VirtualTours: 'Virtual tours',
    RecentlyReduced: 'Recently reduced',
    SellYourHome: 'Sell your home',
    NoObligationCashOffer: 'No obligation cash offer',
    GetaHomeValuation: 'Get a home valuation',
    BecomeaMovotoAgent: 'Join agent network',
    PartnerWitUs: 'Partner with us',
    Agent: 'Agent directory',
    savedSearches: 'Saved searches',
    profile: 'Manage your profile',
    settings: 'Settings',
    HelpCenter: 'Help center',
    meetAgentToday: 'Meet with a real estate agent today',
    call: 'Call',
    careers: 'Careers',
    Faqs: 'FAQ',
    about: 'About',
    press: 'Press',
    feedback: 'Feedback',
    sitemap: 'Sitemap',
    rentalsitemap: 'Rental sitemap',
    blog: 'Movoto blog',
    guide: 'Movoto guide',
    CanadaSite: 'Canada',
    send: 'Send',
    getApp: 'Get the movoto app',
    YourMovoto: 'Your Movoto',
    FindaHome: 'Find a home',
    CustomerService: 'Customer service',
    AgentProfessionals: 'Agent professionals',
};
